import React from "react";
import MasterDataFormV2 from "../../MasterDataFormV2";

const CreateIdcardPage = ({ initialData, onSuccess, onError }) => {
  const fields = [
    {
      name: "photo",
      label: "Photo",
      type: "file",
    },
    {
      name: "name",
      label: "Name",
      type: "text",
    },
    {
      name: "qrCode",
      label: "QR Code",
      type: "text",
    },
    {
      name: "design",
      label: "Design",
      type: "select",
      options: [
        { value: "Standard Blue", label: "Standard Blue" },
        { value: "Premium Gold", label: "Premium Gold" },
        { value: "Classic Black", label: "Classic Black" },
        { value: "Modern White", label: "Modern White" },
      ],
    },
  ];

  return (
    <MasterDataFormV2
      apiUrl="/hr/idcard"
      initialData={initialData}
      fields={fields}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default CreateIdcardPage;
